export default __webpack_public_path__ + "media/components/ParallaxCrayon/crayon_2-5e670fd6dd31857507aa6ce031be346c.png";